import { useEffect, useState } from "react";
import { AccessibilityInfo } from "react-native";

// On web the preference is readable synchronously, so the first render is
// already correct and start-gated animations never start. Native has no
// synchronous API; it resolves on the first effect.
const hasMatchMedia =
  typeof window !== "undefined" && typeof window.matchMedia === "function";

function prefersReducedMotion() {
  return hasMatchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
    : false;
}

export function useReducedMotion() {
  const [reducedMotion, setReducedMotion] = useState(prefersReducedMotion);

  useEffect(() => {
    // Where the media query answered, it is the source of truth: the native
    // probe reports false on web and would undo the correct first render.
    if (!hasMatchMedia) {
      AccessibilityInfo.isReduceMotionEnabled().then(setReducedMotion);
    }
    const subscription = AccessibilityInfo.addEventListener(
      "reduceMotionChanged",
      setReducedMotion,
    );

    return () => subscription.remove();
  }, []);

  return reducedMotion;
}
